<template>
    <div>
        <RPBasicCardVue
            header=" "
            class="rp-track-order-shipment-details"
        >
            <el-row
                slot="header"
                class="rp-shipment-order-main-header"
                v-for="(product,index) in products"
                :key="index"
            >
                <el-col :span="4" class="product-img-header">
                    <el-badge :max="99" :value="parseInt(product.quantity)" class="rp-product-image-overly">
                    <img class="product-img-url" 
                        :src="product.imageURL[0]" 
                        @error="isError = true" 
                        v-if="product.imageURL && !isError"
                    />
                    <img v-else class="product-img-url" src="@/assets/img/No-Image.jpg" />
                    </el-badge>
                </el-col>
                <el-col :span="20" class="rp-shipment-order-product-item">
                    <span class="rp-shipment-order-product-item-title">
                        {{ product.name }}
                    </span>
                </el-col>
            </el-row>
            <div slot="body" class="rp-shipment-order-items-body">
                <div class="rp-richpanel-google-map" v-if="shippingAddress">
                    <RichpanelGoogleMap 
                        :shippingAddress="shippingAddress"
                        :getCityAndState="getCityAndState"
                    />
                </div>
                <div class="shipment-label">
                    <span class="rp-shipment-status"> {{ shipmentHeader }} </span>
                    <span v-if="isRemainingProduct" class="shipment-status-info"> {{ $t('orderList.shipmentDescription') }} </span>
                </div>
                <el-row v-for="(item,index) in trackings" :key="index" class="rp-order-shipment">
                    <el-col :span="24" 
                        :key="i"
                        v-for="(props, i) in getTrackingProperties(item)"
                        class="rp-order-shipment-item"
                        :class="{ 'first-item': i === 0, 'last-item': i === getTrackingProperties(item).length - 1}"
                    >
                    <div class="rp-order-shipment-item-label">
                        {{ props.label }}
                    </div>
                    <div class="rp-order-shipment-item-value-wrapper" :title="props.value">
                        <a :href="props.value"  class="rp-order-shipment-item-value link"  v-if="props.isLink" target="_blank">{{ props.value }}</a>
                        <div  class="rp-order-shipment-item-value" :class="{'show-more': showMoreHandler[i] === 'yes'}" v-else>
                            <span @click="copyToClipboard(props.value)" > 
                                
                                
                            
                                <CopyToClipIcon
                                    :visibleText="'Copy - '+props.label"
                                    :textAfterClick="'Copied '+props.label"
                                    :afterTextTimeSpan="1000"
                                />
                                 {{ showMoreHandler[i] === 'yes' ? props.value : props.value.slice(0, 10) }}{{ props.value && props.value.length>10 && showMoreHandler[i] !== 'yes'? '...': ''}}</span>
                            <a @click="toggleShowMore(i)" v-if="props.value && props.value.length>10" class="show-mre">
                               {{ showMoreHandler[i] === 'yes' ? 'Less' : 'More'}}
                            </a>
                        </div>
                    </div>
                    
                    </el-col>
                </el-row>
            </div>
        </RPBasicCardVue>
    </div>
</template>

<script>

import {
    DateTime
} from 'luxon'
import RichpanelGoogleMap from '../../../shared/RichpanelGoogleMap'
import { formatTheValue } from './../../../constants';
import CopyToClipIcon from './CopyToClipIcon'
export default {
    data() {
        return {
            status: "placed",
            isError: false,
            showMoreHandler: {}
        }
    },
    components: {
        RichpanelGoogleMap,
        CopyToClipIcon
    },
    props: {
        orderShipmentDetails: {
            type: Object
        },
        order: {
            type: Object
        }
    },

    computed: {
        products() {
            return this.orderShipmentDetails.products || [];
        },
        trackings() {
            let trackings = this.orderShipmentDetails.trackings || []
            return trackings
        },
        orderStatus() {
            return this.order && this.order.status && this.order.status.replace('_',' ').toLowerCase()
        },
        shipmentHeader() {
            if (this.isRemainingProduct) {
                return "Your order is" + " " + (this.orderStatus ? this.orderStatus : "accepted")
            } else {
                if (this.isTrackingDetailsAvailable) {
                    return "Your item(s) are" + " " + (this.shipmentStatus ? this.shipmentStatus : "shipped")
                } else {
                    return "Your item(s) are shipped"
                }
            }
        },
        getCityAndState() {
            return (this.orderShipmentDetails.shippingCity || this.order.shippingCity) +", "+ (this.orderShipmentDetails.shippingCountry || this.order.shippingCountry)
        },
        shipmentStatus() {
            return this.orderShipmentDetails && this.orderShipmentDetails.status && this.orderShipmentDetails.status.replace('_',' ').toLowerCase()
        },
        isRemainingProduct() {
            return this.orderShipmentDetails.isRemainingProduct
        },
        shippingAddress() {
            if (this.fullfillmentAddress) {
                return this.fullfillmentAddress
            } else {
                return this.getOrderAddress
            }
        },
        
        fullfillmentAddress() {
            let {
                shippingAddressLine1,
                shippingCity,
                shippingRegion,
                shippingPostcode,
                shippingCountry
            } = this.orderShipmentDetails
            shippingCountry = shippingCountry ? shippingCountry.toUpperCase() : shippingCountry;

            const values = [
                shippingAddressLine1,
                shippingCity,
                shippingRegion,
                shippingCountry,
                shippingPostcode,
            ].filter(value => !!(value && value.trim()))

            return values.join(', ')
        },
        isTrackingDetailsAvailable() {
            return this.orderShipmentDetails.trackings && this.orderShipmentDetails.trackings.length  ? true : false
        },
        getOrderAddress() {
            let {
                shippingAddressLine1,
                shippingCity,
                shippingRegion,
                shippingPostcode,
                shippingCountry
            } = this.order
            shippingCountry = shippingCountry ? shippingCountry.toUpperCase() : shippingCountry;

            const values = [
                shippingAddressLine1,
                shippingCity,
                shippingRegion,
                shippingCountry,
                shippingPostcode,
            ].filter(value => !!(value && value.trim()))

            return values.join(', ')
        }
    },
    methods: {
        toggleShowMore(propLabel) {
            propLabel = propLabel + '';
            let vale  = this.showMoreHandler[propLabel] === 'yes' ? 'no' : 'yes'
            this.$set(this.showMoreHandler, propLabel, vale);
        },
        copyToClipboard(input) {
            let value

            if (typeof input !== 'string') {
                try {
                value = JSON.stringify(input)
                } catch (e) {
                throw copyErrorMessage
                }
            } else {
                value = input
            }

            const textarea = document.createElement('textarea')

            textarea.value = value
            textarea.setAttribute('readonly', '')
            textarea.style.cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;'

            document.body.appendChild(textarea)

            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                textarea.contentEditable = true
                textarea.readOnly = true

                const range = document.createRange()

                range.selectNodeContents(textarea)

                const selection = window.getSelection()

                selection.removeAllRanges()
                selection.addRange(range)
                textarea.setSelectionRange(0, 999999)
            } else {
                textarea.select()
            }

            let success = false

            try {
                success = document.execCommand('copy')
            } catch (err) {
                console.warn(err)
            }

            document.body.removeChild(textarea)
            return success
        },

        getTrackingProperties(tracking) {
            let properties = []
            if(tracking) {
                if(tracking.trackingCompany)  {
                    properties.push({
                        label: 'Sent Via',
                        value: tracking.trackingCompany
                    })
                }
                if(tracking.trackingUrl)  {
                    properties.push({
                        label: 'Tracking Url',
                        value: tracking.trackingUrl,
                        isLink: true
                    })
                }
                if(tracking.trackingNumber)  {
                    properties.push({
                        label: 'Tracking Number',
                        value: tracking.trackingNumber
                    })
                }
                if(tracking.shippingDate)  {
                    properties.push({
                        label: 'Ship Date',
                        value: formatTheValue(tracking.shippingDate, 'date')
                    })
                }
            }
            return properties
        },
        handleOrderAction({ actionName, payload }) {
			this.$emit(actionName, payload)
    	},
        onTrackUrlClick(url) {
            window.open(url, "_blank");
        },
        parsedTime(createdAt) {
            let shippingDate = parseInt(createdAt)
            return "Shipped on" + " " +  (DateTime.fromMillis(shippingDate).setLocale(this.$root.defaultLanguage).toFormat('LLL dd'));
        },
    }
}
</script>

<style lang="scss">
.rp-track-order-shipment-details {
    margin: 16px;
    padding: 0px !important;
    font-size: 15px;
    .rp-custom-card__header {
        padding: unset !important;
        background: #fff !important;
    }
    .rp-shipment-order-main-header {
        padding: 20px;
        @include for-size(tablet-landscape-up){
            padding: 40px;
            padding-bottom: 0px;
        }
        @include for-size(desktop-up){
            padding: 35px 60px 0px 60px;
        }
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 0px;
        &:last-child {
            padding-bottom: 20px;
            @include for-size(tablet-landscape-up){
                padding-bottom: 40px;
            }
            @include for-size(desktop-up){
                padding-bottom: 60px;
            }
        }
        &:first-child {
            padding-top: 20px;
            @include for-size(tablet-landscape-up){
                padding-top: 40px;
            }
            @include for-size(desktop-up){
                padding-top: 60px;
            }
        }
        .rp-product-body {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            text-align: left;
            padding-left: 12px;
        }
        .product-img-header {
            border: 1px solid #e6e3e3;
            border-radius: 3px;
            padding: 8px;
            width: 48px;
            .product-img-url {
                height: 30px;
                width: 30px;
            }
            .rp-product-image-overly {
                height: 30px;
                .el-badge__content {
                    background-color: #4d4d4d !important;
                    display: inline-block;
                    height: 25px;
                    width: 25px;
                    border-radius: 25px;
                    line-height: 23px;
                    padding: 0 0px;
                    text-align: center;
                    white-space: nowrap;
                    color: #fff;
                    font-weight: 500;
                    font-size: 15px;
                    border: none;
                }
            }
        }
        .rp-shipment-order-product-item {
            flex: 1;
            display: flex;
            flex-direction: row;
            flex-flow: wrap;
            padding-left: 1rem;
            .rp-shipment-order-product-item-title {
                font-weight: 400;
                color: #333333;
                text-transform: capitalize;
                padding-right: 5px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                line-height: 1.2;
            }
        }
    }
    .gmnoscreen {
        display: none !important;
    }
    .rp-shipment-order-items-body {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #ffffff;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        .shipment-label {
            padding: 20px;
            color: #333333;
            font-weight: 400;
            display: flex;
            font-size: 22px;
            @include for-size(tablet-landscape-up){
                padding: 40px;
            }
            @include for-size(desktop-up){
                padding: 60px;
            }
            @include for-size(desktop-up){
                font-size: 26px;
            }
            flex-direction: column;
            align-items: flex-start;
            overflow: hidden;
            .rp-shipment-status {
                line-height: 19px;
            }
            .shipment-status-info {
                font-weight: 400;
                color: #666666;
                font-size: 15px;
                 @include for-size(desktop-up){
                    font-size: 19px;
                    line-height: 1.6;
                }
                white-space: normal;
                text-align: left;
                word-break: break-word; 
                padding-top: 0.3rem;
            }
        }
        .shipment-type {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-top: 1px solid #ccc;
            padding: 19px 20px 20px;
            background: #ffffff;
            border-bottom-left-radius: 7px;
            border-bottom-right-radius: 7px;
            @include for-size(tablet-landscape-up){
                padding: 30px 40px 40px;
            }
            @include for-size(desktop-up){
                padding:  50px 60px 60px;
            }
            .rp-shipment-tracking-details {
                display: flex;
                justify-content: flex-start;
            }
            .shipment-details {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                word-break: break-word;
                overflow: hidden;
                &.add-gutter {
                    padding-right: 10px;
                }
                justify-content: center;
                color: #4d4d4d;
                white-space: nowrap;
                .tracking-company-name {
                    font-weight: 400;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 100%;
                    text-align: start;
                }
                .rp-tracking-no {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: start;
                    width: 100%;
                }
                .rp-clickable-tracking-no {
                    color: #1f569b;
                    cursor: pointer;
                    text-decoration-style: solid;
                    font-weight: 400;
                    text-decoration: underline;
                    text-underline-position: under;
                    text-decoration-color: #7aa5dc;
                    line-height: 20px;
                }
                .tracking-date {
                    color: #4d4d4d;
                }
            }
        }
    }
}
.rp-order-shipment {
    margin: 0 1rem;
    border-top: 1px solid #ccc;
}
.rp-order-shipment-item {
    display:flex;
    padding: 0.5rem 0;
    line-height: 1.3;
    &.first-item {
        padding-top: 1rem;
    }
    &.last-item {
        padding-bottom: 1rem;
    }
    .rp-order-shipment-item-label {
        width: 50%;
        padding-right: 10px;
        @include textOverFlowElipses();
    }
    .rp-order-shipment-item-value-wrapper {
        width: 50%;
        .rp-order-shipment-item-value {
            cursor: pointer;
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            word-break: break-word;
            &.link, .show-mre {
                color: #004e96;
                @include textOverFlowElipses();
            }
            .show-mre {
                font-size: 12px;
            }

            &.show-more {
                
            }
    }
    }
    

}
</style>